import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import { IListItem } from '@/models/common/list-item';

@Component
export default class CheckboxListComponent extends Vue {
    
    @Prop() value: any[]
    @Prop() options: IListItem[]

    @Emit('input')
    valueChanged(newValue: any[]) {
        this.selectAll = newValue.length == this.options.length
    }

    @Watch('value', { immediate: true })
    valuePropChanged(value: any[]) {
        this.selectAll = value.length == this.options.length
    }

    selectAllClicked(value: any) {
        if (value) {
            this.valueChanged(this.options.map(x => x.value))
        }
        else {
            this.valueChanged([])
        }
    }

    selectAll: boolean = false
}
